import { Component,EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { ToastClientService } from 'src/app/services/toast/toast-client.service';

@Component({
  selector: 'app-multilang',
  templateUrl: './multilang.component.html',
  styleUrls: ['./multilang.component.scss']
})
export class MultilangComponent implements OnInit {

  @Input() fieldTitle:any;
  @Input() languages:any;
  @Input() fields:any;
  @Input() formData:any;
  @Input() questionIndex:any
  @Input() optionIndex:any
  @Input() moduleName:string;
  @Output() modalDismiss = new EventEmitter<void>(); // Notify parent
  langForm: FormGroup;
  isSubmitting:boolean = false
  questionField:any;
  localData:any;

  constructor( 
      private fb: FormBuilder,
      private apiService: ApiService,
      private apiConfig: ApiConfiguration,
      private toast: ToastClientService,
      private modalService: NgbModal,) { }

  ngOnInit() {
    console.log(this.languages);
    console.log(this.fieldTitle);
    console.log(this.fields);
    console.log(this.formData); 
    
    this.initializeForm(this.formData)

    if(this.moduleName == "engagement"){
      this.localData = JSON.parse(localStorage.getItem('engagementDetail'))
    }
  }

  ngDoCheck(){
  }

  initializeForm(data?) {
    console.log(data);
    const group: any = {};
    this.fields.forEach((field) => {
      switch (field.type) {
        case 'control':
          if( data[field.name] !== null && typeof data[field.name] === "string"){
            group[field.name] = this.createPrepopulatedMultiLangGroup(JSON.parse(data[field.name]))
          }else if (data[field.name] !== null && typeof data[field.name] !== "string"){
            group[field.name] = this.createPrepopulatedMultiLangGroup(data[field.name])
          }else{
            group[field.name] = this.createMultiLangGroup()
          }
          // group[field.name] = data[field.name] !== null 
          // ?this.createPrepopulatedMultiLangGroup(JSON.parse(data[field.name])):this.createMultiLangGroup();
          break;
        case 'array':
          if(field.title == "question and option"){
            this.questionField = field.name
          }
          group[field.name] = this.fb.array(
            data[field.name].map((item) => this.createQuestionGroup(item))
          );
          break;
      }
    });
    this.langForm = this.fb.group(group);
    console.log(this.langForm);
  }

  createMultiLangGroup(): FormGroup {
    const group: any = {};
    this.languages.forEach((language) => {
      group[language.short_name] = this.fb.group({
        id: new FormControl(language.id),
        value: new FormControl(''),
      });
    });
    return this.fb.group(group);
  }

  createQuestionGroup(item: any) {
    return this.fb.group({
      question: item.question_multilang?this.createPrepopulatedMultiLangGroup(JSON.parse(item.question_multilang)):this.createMultiLangGroup(),
      options: this.fb.array(
        item.option_multiLang.map((option: any) =>
          option !== null ? this.createPrepopulatedMultiLangGroup(JSON.parse(option)):this.createMultiLangGroup()
        )
      ),
    });
  }

  createPrepopulatedMultiLangGroup(data?: any): FormGroup {
    console.log(data);
    const group: any = {};
    this.languages.forEach((lang) => {
      group[lang.short_name] = this.fb.group({
        id: new FormControl(data[lang.short_name].id ),
        value: new FormControl(data[lang.short_name].value),
      });
    });
    return this.fb.group(group);
  }

  get questions(): FormArray {
    return this.langForm.get(this.questionField) as FormArray;
  }

  addQuestion() {
    if(this.questions){
      const questionGroup = this.fb.group({
        question: this.createMultiLangGroup(),
        options: this.fb.array([]),
      });

      this.questions.push(questionGroup);
  
      for (let i = 0; i < 4; i++) {
        this.addOption(this.questions.length - 1);
      }
      console.log(this.langForm);
    }else{
      return
    } 
  }

  get options(): FormArray {
    return this.questions.at(0).get('options') as FormArray;
  }

  addOption(questionIndex: number) {
    this.options.push(this.createMultiLangGroup());
  }

  
  deleteQuestionMulti(questionIndex){
    this.questions.removeAt(questionIndex)
  }

  deleteOptionMulti(questionIndex:number,optionIndex:number){
    console.log(questionIndex,optionIndex);
    console.log(this.langForm);
    (this.questions.at(questionIndex).get("options")as FormArray).removeAt(optionIndex)
  }


  closeModal() {
    // this.selectedQuestionIndex = null
    // this.selectedOptionIndex = null
    this.modalDismiss.emit()
    this.modalService.dismissAll()
  }

  onLangSubmit(field){
    this.isSubmitting = true;
    console.log(this.langForm.value);
    if(this.moduleName == "engagement"){
      this.engagementMultiLang()
    }
    if(this.moduleName == "dynamic_fields"){
      this.dynamicMultilang()
    }
  }

  engagementMultiLang(){

    let payload = {
      engagement_type : this.localData.engagement_type_id,
      engagement_task_id : this.localData.task_id,
      is_quiz_configured :this.localData.quiz_configured,
      course_title_multilang : this.langForm.value.course_title_multilang,
      course_quiz_multilang : this.langForm.value.course_quiz
    }
    
    this.apiService.post(this.apiConfig.engagementMultilang,payload)
    .subscribe((res:any)=>{
      if(res.body.status == 200){
        this.toast.Success(res.body.data)
        this.closeModal()
      }
    })

  }

  dynamicMultilang(){
    let payload = {
      lable_name_multilang: this.langForm.value.lable_name_multilang,
      field_short_name  : this.formData.field_short_name,
      id : this.formData.id
    }

    console.log(payload);

    this.apiService.post(this.apiConfig.dynamicRoleMultilang,payload)
    .subscribe((res:any)=>{
      if(res.body.status == 200){
        this.toast.Success(res.body.data)
        this.closeModal()
      }
    })
    
  }

}
